import React, { useState } from 'react';
import { Alert, Container, Image, Spinner, Button, Table, Card, Col, Form, Toast, Tabs, Tab, ListGroup } from 'react-bootstrap';
import TableReactBootstrapNext from '../components/TableReactBootstrapNext.js';

import LogoGPM from '../assets/images/logo.png';
import Axios from 'axios';
import './ConsultaTramitesBPM.css';

export default function ConsultaTramitesBPM() {
  const [tramiteData, setTramiteData] = useState({});
  const [tipoConsulta, setTipoConsulta] = useState('');
  const [value, setValue] = useState('');
  const [validValue, setValidValue] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toastData, setToastData] = useState({ show: false, message: '', title: '' });


  const columnsTraza = [
    { dataField: 'tarea', text: 'Tarea' },
    { dataField: 'fecha_asignacion', text: 'Fecha de Asignación' },
    { dataField: 'fecha_fin', text: 'Fecha de Finalización' },
    { dataField: 'usuario', text: 'Usuario' },
    { dataField: 'estado', text: 'Estado' },
  ];

  const columnsTramitePago = [
    { key: "objeto_pago", name: "Objeto de Contratación" },
    { key: "objeto_contratacion", name: "Tipo de Solicitud de Pago" },
    { key: "tipo_contratacion", name: "Tipo de Contratación" },
    { key: "tipo_pago", name: "Tipo de Pago" },
    { key: "razon_social", name: "Contratista" },
    { key: "ruc_rup_proveedor", name: "RUC/RUP del Proveedor" },//Dentro del Contratista
    { key: "fecha_ingreso_solicitud", name: "Fecha de Ingreso de la Solicitud" },
    { key: "ingresado_por", name: "Ingresado por" },
    { key: "direccion_requirente", name: "Dirección del Requirente" },
    { key: "estado", name: "Estado" },
    { key: "codigo_contratacion_sercop", name: "Código Contratación SERCOP" },

    // { key: "tarea", name: "Ultima Tarea Registrada", hide: true },
    // { key: "bandeja", name: "Estado del Flujo", hide: true },
    //! { key: "base_imponible", name: "Base Imponible", hide: true },
    // { key: "sumatoria_total", name: "Sumatoria Total", hide: true },
    // { key: "fecha_acreditacion", name: "Fecha de Acreditación", hide: true },
    // {key: "codigo_aflow", name: "Código aFlow"},
    // {key: "codigo_erp", name: "Código ERP"},
    // {key: "iva", name: "IVA"},
    // {key: "numero_pago_planilla", name: "Concepto de Pago"},
    // {key: "numero_solicitud_pago", name: "Número de la Solicitud de Pago"},
    // {key: "numero_tramite", name: "Número de Trámite"},
    //! {key: "subtotal_0", name: "SubTotal 0%"},
    //! {key: "subtotal_12", name: "SubTotal 12%"},
  ];

  const columnsTramiteCiudadano = [
    { key: 'codigo_aflow', name: "Código del Trámite" },
    { key: 'numero_tramite', name: "Número del Trámite" },
    { key: 'solicitante', name: "Solicitante" },
    // {key: 'tipo', name:"Tipo"},
    { key: 'fecha_documento', name: "Fecha Documento" },
    { key: 'fecha_ingreso_sistema', name: "Fecha Ingreso Sistema" },
    { key: 'canton', name: "Canton" },
    { key: 'parroquia', name: "Parroquia" },
    { key: 'departamento', name: "Departamento" },
    { key: 'estado', name: "Estado" },
    { key: 'ingresado_por', name: "Ingresado por" },
    { key: 'resumen', name: "Resumen" },
  ];

  async function handleSubmit() {
    setLoading(true);
    Axios.get(`https://apiservices.manabi.gob.ec/api-gestion_proyectos/v1/bpm/buscarTramiteCiudadano?tipo_consulta=${tipoConsulta}&tramite=${value}`)
      .then((response) => {
        const { data } = response;
        setTramiteData({ ...data.data, tipo: "ciudadana" });
        setLoading(false);
      }).catch((error) => {
        // console.log(error);
        if (error.response.status === 404) {
          // alert("Trámite no encontrado");
          // setToastData({ show: true, message: `Estimado usuario(a). El Trámite con Número/Código ${value} no ha sido encontrado.`, title: 'Trámite no encontrado' });
          Axios.get(`https://apiservices.manabi.gob.ec/api-gestion_proyectos/v1/bpm/buscarTramitePagoProveedor?tipo_consulta=${tipoConsulta}&tramite=${value}`)
            .then((response) => {
              const { data } = response;
              setTramiteData({ ...data.data, tipo: "pago_proveedor" });
              setLoading(false);
              return true;
            }).catch((error) => {
              console.log(error);
              if (error.response.status === 404) {
                // alert("Trámite no encontrado");
                setToastData({ show: true, message: `Estimado usuario(a). El Trámite con Número/Código ${value} no ha sido encontrado.`, title: 'Trámite no encontrado' });
              } else if (error.response.status === 429) {
                setToastData({ show: true, message: `Estimado usuario(a).` + error.response.data, title: 'Demasiadas solicitudes' });
              } else {
                alert("Hubo un error. Reportelo con el Administrador.\n" + JSON.stringify(error));
              }
              setLoading(false);
            });

        } else if (error.response.status === 429) {
          setToastData({ show: true, message: `Estimado usuario(a).` + error.response.data, title: 'Demasiadas solicitudes' });
          setLoading(false);
        } else {
          alert("Hubo un error. Reportelo con el Administrador.\n" + JSON.stringify(error));
          setLoading(false);
        }
      });
  }

  const SpinnerLoader = (props) => {
    return (
      <Spinner animation="border" role="status" style={{
        position: props.position,
        top: "50%",
        left: "50%",
        marginTop: "-50px",
        marginLeft: "-50px",
        width: "100px",
        height: "100px",
        color: "#137b43"
      }}>
        <span className="sr-only">Loading...</span>
      </Spinner>
    )
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter' && validValue) {
      handleSubmit();
    }
  }

  function handleDownloadDocument() {
    setLoading(true);
    Axios.get(`https://apiservices.manabi.gob.ec/api-gestion_proyectos/v1/bpm/enviarRespuestaTramite?id_tramite=${tramiteData.tramite.numero_tramite}`).then((response) => {
      setToastData({ show: true, message: `Estimado usuario(a). El documento ha sido enviado, revise la bandeja de su correo.`, title: 'Documento enviado.' });
      setLoading(false);
    }).catch((error) => {
      console.log();
      if (error.response.status === 404) {
        setToastData({ show: true, message: `Estimado usuario(a). No se encontraron documentos para enviar por correo.`, title: 'Documento no encontrado' });
      } else if (error.response.status === 429) {
        setToastData({ show: true, message: `Estimado usuario(a).` + error.response.data, title: 'Demasiadas solicitudes' });
      } else {
        alert("Hubo un error. Reportelo con el Administrador.\n" + JSON.stringify(error));
      }
      setLoading(false);
    });
  }

  function handleSendEmailPago() {
    setLoading(true);
    Axios.get(`https://apiservices.manabi.gob.ec/api-gestion_proyectos/v1/bpm/sendDataTramitePagoProveedor?tramite=${tramiteData.tramite.numero_tramite}`).then((response) => {
      setToastData({ show: true, message: `Estimado usuario(a). El documento ha sido enviado, revise la bandeja de su correo.`, title: 'Documento enviado.' });
      setLoading(false);
    }).catch((error) => {
      console.log();
      if (error.response.status === 404) {
        setToastData({ show: true, message: `Estimado usuario(a). No se encontraron documentos para enviar por correo.`, title: 'Documento no encontrado' });
      } else if (error.response.status === 429) {
        setToastData({ show: true, message: `Estimado usuario(a).` + error.response.data, title: 'Demasiadas solicitudes' });
      } else {
        alert("Hubo un error. Reportelo con el Administrador.\n" + JSON.stringify(error));
      }
      setLoading(false);
    });
  }


  return (
    <>
      <Container style={{ marginBottom: '55px' }}>
        <Toast
          className="position-fixed"
          show={toastData.show}
          onClose={() => setToastData({ show: false, message: '', title: '' })}
          delay={5000}
          autohide
          style={{ display: toastData.show ? 'block' : 'none', position: 'absolute', top: '1rem', right: '1rem', zIndex: 9999 }}
        >
          <Toast.Header>
            <strong className="mr-auto">{toastData.title}</strong>
          </Toast.Header>
          <Toast.Body>{toastData.message}</Toast.Body>
        </Toast>

        <Alert variant="success" style={{ backgroundColor: '#157a44' }}>
          <Alert.Heading style={{ justifyContent: 'center', textAlign: 'center' }}>
            {/* <p style={{ color: 'white', fontSize: 'larger', fontWeight: '700' }}>SOLICITUDES CIUDADANAS</p> */}
          </Alert.Heading>
          <div style={{ justifyContent: 'center', textAlign: 'center' }}>
            <Image style={{ textAlign: "center", filter: "brightness(500%)" }} src={LogoGPM} fluid />
          </div>
          <hr />
        </Alert>
        <Container>
          <Card className="text-center" style={{ margin: '10px auto 2px auto', width: '90%' }}>
            <Card.Header style={{ textAlign: 'center' }}>
              <h4>Consulta tú trámite</h4>
            </Card.Header>
            <Card.Body style={{ textAlign: 'center' }}>
              Ingresa tu número o código de trámite en el siguiente recuadro y dale clic en buscar.
              <hr />
              <Form.Group as={Col} className="justify-content-md-center" md="6" style={{ margin: '10px auto 2px auto' }} >
                <Form.Control
                  as="input"
                  required
                  isInvalid={!validValue && value.length > 0}
                  type="text"
                  isValid={validValue}
                  placeholder={'Número/Código de Trámite'}
                  value={value}
                  onKeyPress={handleKeyPress}
                  onChange={event => {
                    let val = event.target.value.toUpperCase();
                    setValue(val);
                    if (val.length >= 3 && val.includes('GPM')) {
                      setValidValue(true);
                      setTipoConsulta('codigo_tramite');
                    } else if (/^\d+$/.test(val)) {
                      setValidValue(true);
                      setTipoConsulta('numero_tramite');
                    } else {
                      setTipoConsulta('');
                      setValidValue(false);
                    }
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Ingrese un número/código de Tramite valido.
                </Form.Control.Feedback>
                {tipoConsulta !== '' && value.length > 0 && <Form.Label style={{ fontWeight: 'initial', fontSize: 'small' }}>Se buscará por: <strong>{tipoConsulta === 'numero_tramite' ? 'Número de Tramite' : (tipoConsulta === 'codigo_tramite' ? 'Código de Tramite' : '')}</strong></Form.Label>}
              </Form.Group>
            </Card.Body>
            <Card.Footer style={{ justifyContent: 'space-around', display: 'flex' }}>
              <Button variant="success" disabled={!validValue || loading} onClick={() => { validValue ? handleSubmit() : alert("Ingrese un valor valido !!!") }}>                
                {(!loading || Object.keys(tramiteData).length !== 0) && "Buscar"}
                {loading && Object.keys(tramiteData).length === 0 && <Spinner animation="border" variant="light" />}
                </Button>
              <Button variant="success" onClick={() => {
                setTramiteData({});
                setValue('');
                setValidValue(false);
              }}>Nueva Consulta</Button>
            </Card.Footer>
          </Card>
        </Container>
        <Container style={{ marginTop: "10px", paddingTop: "10px" }}>
          {loading && Object.keys(tramiteData).length === 0 && <div style={{ height: "20rem", zIndex: 10000 }}><SpinnerLoader position="relative" /></div>}
          {'tramite' in tramiteData && Object.keys(tramiteData.tramite).length > 0 && tramiteData.tipo === 'ciudadana' &&
            <Tabs className="tab-rb">
              <Tab eventKey="detalle_tramite" title="Trámite de Solicitud Ciudadana">
                <Table style={{ padding: '0 !important' }}>
                  <tbody>
                    {columnsTramiteCiudadano.map((column, index) => {
                      const { key, name } = column;
                      if (key in tramiteData.tramite && tramiteData.tramite[key] !== null) {
                        return <tr key={index}>
                          <td className="label-table-header">{name}</td>
                          <td colSpan="2">{'codigo_aflow' in tramiteData.tramite ? tramiteData.tramite[key] : 'NULL'}</td>
                        </tr>
                      } else {
                        return "";
                      }
                    })}
                  </tbody>
                </Table>
              </Tab>
              <Tab eventKey="traza_tramite" title="Traza del Trámite">
                {'traza' in tramiteData && tramiteData.traza.length > 0 && <TableReactBootstrapNext
                  data={tramiteData.traza}
                  columns={columnsTraza}
                  keyField="id"
                  showPagination={false}
                  responsive
                />}
              </Tab>
              {'document' in tramiteData && tramiteData.document.exists_file &&
                <Tab eventKey="respuesta_tramite" title="Respuesta del Trámite">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h5">Respuesta del Trámite</Card.Title>
                    </Card.Header>
                    {!loading ?
                      <>
                        <Card.Body style={{ textAlign: 'center' }}>
                          <p>El trámite será enviado a el(los) siguiente(s) correo(s):</p>
                          <ListGroup>
                            {tramiteData.document.emails.map((email, index) => {
                              return <ListGroup.Item key={index}>{email}</ListGroup.Item>
                            })}
                          </ListGroup>
                        </Card.Body>
                        <Card.Footer style={{ justifyContent: 'space-around', display: 'flex' }}>
                          <Button variant="success" onClick={() => { handleDownloadDocument() }}>Enviar Documento a el(los) correo(s)</Button>
                        </Card.Footer>
                      </> : <div style={{ height: "20rem", zIndex: 10000 }}><SpinnerLoader position="relative" /></div>}
                  </Card>
                </Tab>}
            </Tabs>
          }
          {'tramite' in tramiteData && Object.keys(tramiteData.tramite).length > 0 && tramiteData.tipo === 'pago_proveedor' &&
            <Tabs className="tab-rb">
              <Tab eventKey="detalle_tramite" title="Trámite de Pago">
                <Table style={{ padding: '0 !important' }}>
                  <tbody>
                    {columnsTramitePago.map((column, index) => {
                      const { key, name } = column;
                      if (key in tramiteData.tramite && tramiteData.tramite[key] !== null) {
                        return <tr key={index}>
                          <td className="label-table-header">{name}</td>
                          <td colSpan="2">
                            <p style={{ display: 'inline', padding: "0.5rem", borderRadius: "12px", border: key === "estado" ? "1px solid black" : "", backgroundColor: key === "estado" ? (tramiteData.tramite[key] === "PAGADO" ? "#3bdd3b" : "yellow") : "" }}>{'codigo_aflow' in tramiteData.tramite ? tramiteData.tramite[key] : 'NULL'}</p>
                          </td>
                        </tr>
                      } else {
                        return ""
                      }
                      
                    })}
                      {'correo_proveedor' in tramiteData.tramite && tramiteData.tramite.correo_proveedor !== null && tramiteData.tramite.correo_proveedor !== "None" && <tr>
                          <td colSpan="2">
                            <Card>
                              <Card.Body style={{textAlign: "center"}}>
                                La información detallada del tramite puede ser enviada al siguiente correo: <strong>{tramiteData.tramite.correo_proveedor}</strong>
                              </Card.Body>
                              <Card.Footer style={{display: "flex", justifyContent: "center"}}>
                                <Button variant="success" onClick={() => {handleSendEmailPago()}}>Enviar Información</Button>
                              </Card.Footer>
                            </Card>                            
                          </td>
                        </tr>
                      }
                  </tbody>
                </Table>
              </Tab>
            </Tabs>
          }
        </Container>
      </Container>
      <div style={{
        backgroundColor: 'rgb(34, 123, 67)',
        borderRadius: '3px',
        display: 'block',
        position: 'fixed',
        bottom: '0',
        marginTop: '52px',
        width: '100%',
        right: 0,
      }}>
        <p style={{ color: 'white', padding: '.6rem 1.4rem', margin: 0, fontWeight: '300', fontSize: 'small' }}>©Copyright <strong>Prefectura de Manabí</strong>. All rights reserved.</p>
      </div>
    </>
  )
}
